module.exports = __webpack_public_path__ + "img/ai_recycle_05.999e892e.png";